import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface PolicyLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

function PolicyLayout({ title, lastUpdated, children }: PolicyLayoutProps) {
  return (
    <div className="max-w-4xl mx-auto">
      {/* Breadcrumb */}
      <nav className="flex items-center gap-2 text-sm text-gray-500 mb-8">
        <Link to="/" className="hover:text-gray-900">Home</Link>
        <ChevronRight className="h-4 w-4" />
        <span className="text-gray-900">{title}</span>
      </nav>

      {/* Header */}
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">{title}</h1>
        <p className="text-gray-500">Last updated: {lastUpdated}</p>
      </div>

      {/* Content */}
      <div className="prose prose-lg prose-indigo max-w-none">
        {children}
      </div>
    </div>
  );
}

export default PolicyLayout;